import React, {Component} from "react";
import FeedRequestComponent from "../components/FeedRequestComponent";
import getNumberFromText from "../utils/helper/extractionNumber";
import FeedProposeComponent from "../components/FeedProposeComponent";
import FeedFollowComponent from "../components/FeedFollowComponent";

class FeedSwitchContainer extends Component{
    render() {
        switch (this.props.verb){
            case "request":
                return(
                        <FeedRequestComponent
                            id={this.props.id}
                            user={this.props.user}
                            verb={this.props.verb}
                            time={this.props.time}
                            object={this.props.object}
                            foreign_id={getNumberFromText(this.props.foreign_id)}
                        />
                    )
            case "propose":
                return (
                    <FeedProposeComponent
                        id={this.props.id}
                        user={this.props.user}
                        verb={this.props.verb}
                        time={this.props.time}
                        object={this.props.object}
                        foreign_id={getNumberFromText(this.props.foreign_id)}
                    />
                )
            case "follow":
                return (
                    <FeedFollowComponent/>
                )
            default:
                return <></>
        }
    }
}

export default FeedSwitchContainer